// extracted by mini-css-extract-plugin
export default {"BrandLogo__animate":"BrandLogo_BrandLogo__animate__r87BS","OpacityAnimate":"BrandLogo_OpacityAnimate__B+O50"};